import { forwardRef, useId, type SelectHTMLAttributes } from 'react';

export interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: { value: string; label: string }[];
  placeholder?: string;
}

const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(function SelectField({ label, error, options, placeholder, id, className = '', ...rest }, ref) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  return (
    <div className={`field ${className}`}>
      {label && <label htmlFor={fieldId}>{label}</label>}
      <select ref={ref} id={fieldId} className="select" aria-invalid={!!error || undefined} {...rest}>
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {error && <span className="error">{error}</span>}
    </div>
  );
});
export default SelectField;
